import { Button, Tooltip } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { IArquivoDespesaCleanDTO } from '../../../../models/happy-code-api.model';
import Styles from '../despesa.module.scss';
import { formattedDate } from '../../../../util/format';
import { UploadFile } from 'antd/lib/upload/interface';

interface FileListProps {
	arquivos: IArquivoDespesaCleanDTO[];
	onDownload: (hash: string, fileName: string) => any;
	onDelete?: (file: UploadFile) => void;
}

export default function FileListComponent({ arquivos, onDownload, onDelete }: FileListProps) {
	return (
		<div className={Styles.fileListContainer}>
			{arquivos?.length > 0 ? (
				<ul className={Styles.fileList}>
					{arquivos.map((arquivo) => (
						<li key={arquivo.arquivo.id} className={Styles.fileItem}>
							<div className={Styles.fileInfo}>
								<span className={Styles.fileName}>{arquivo.arquivo.codigo}</span>
								{arquivo.arquivo.descricao && <span className={Styles.fileDescription}>{arquivo.arquivo.descricao}</span>}
								{arquivo.arquivo.dataCriacao && (
									<span className={Styles.fileDescription}>
										Anexado por: {arquivo?.usuario || 'unknown'} em: {formattedDate(arquivo.arquivo.dataCriacao)}
									</span>
								)}
							</div>
							<div style={{ display: 'flex', gap: 8 }}>
								<Tooltip title="Baixar arquivo">
									<Button
										icon={<DownloadOutlined rev={undefined} />}
										onClick={() => onDownload(arquivo.arquivo.url, arquivo.arquivo.codigo.split(' ')[0])}
										className={Styles.downloadButton}
									>
										Baixar
									</Button>
								</Tooltip>
								{onDelete && (
									<Tooltip title="Excluir arquivo">
										<Button
											type="link"
											onClick={() =>
												onDelete?.({
													uid: String(arquivo.arquivo.id),
													name: arquivo.arquivo.codigo,
													response: { id: arquivo.arquivo.id },
												} as UploadFile)
											}
											className={Styles.deleteButton}
											style={{ color: 'red' }}
										>
											Excluir
										</Button>
									</Tooltip>
								)}
							</div>
						</li>
					))}
				</ul>
			) : (
				<p className={Styles.emptyList}>Sem arquivos anexados.</p>
			)}
		</div>
	);
}
